export default "__VITE_ASSET__AILEkb6A__"